export default __webpack_public_path__ + "e0ac556c085ea83ba30e06ef3754c17c.png";